export const ky = {
    "n1": "Башкы бет",
    "n2": "Заказ",
    "n3": "транзакция",
    "n4": "команда",
    "n5": "меники",
    "t1": "бир нерсе ката кетти",
    "t2": "Ийгиликтүү көчүрүлдү",
    "t3": "Сураныч, маалыматты толугу менен толтуруңуз",
    "t4": "Жүктөлүүдө…",
    "t5": "Кирүү ийгиликтүү",
    "t6": "Тапшыруу үчүн 3 баллдан жогору болушу керек",
    "t7": "Тапшыруу ийгиликтүү болду",
    "t8": "Баланс жетишсиз, алуу мүмкүн эмес",
    "t9": "Тапшырылган жок",
    "t10": "Сураныч, адегенде даректи байлаңыз, ошондо сиз жеке борбордун барагына багытталасыз.",
    "t11": "Дарек байланган, аны өзгөртүү үчүн кардарларды тейлөөгө кайрылыңыз.",
    "t12": "Өзгөртүү ийгиликтүү болду",
    "t13": "Өзгөртүү ишке ашкан жок",
    "t14": "Сырсөзүңүздү өзгөртүү үчүн кардарларды тейлөөгө кайрылыңыз",
    "t15": "Сырсөз форматында ката",
    "t16": "Ийгиликтүү алып салуу",
    "t17": "Чектөө мүмкүн болгон максималдуу сумма",
    "t18": "Минималдуу алып салуу",
    "t19": "Эки сырсөз дал келбейт",
    "t20": "Кеңештер",
    "t21": "Учурда секире албай жатат",
    "t22": "Сырсөз форматында ката",
    "t23": "Каттоо ийгиликтүү болду",
    "t24": "Аймактын кодун киргизиңиз",
    "t25": "Мындан ары жок",
    "l1": "Тил",
    "l2": "Сураныч, эсеп номерин киргизиңиз",
    "l3": "Сырсөздү киргизиңиз",
    "l4": "эсте",
    "l5": "Кирүү",
    "l6": "Каттоого барыңыз",
    "l7": "Эсеп жок",
    "l8": "Мобилдик телефон номери",
    "l9": "лакап ат",
    "l10": "Сырсөз",
    "l11": "Сырсөздү ырастоо",
    "l12": "Чакыруу коду",
    "l13": "Каттоо",
    "l14": "Каттоо эсебиңиз бар",
    "l15": "Логинге өтүңүз",
    "l16": "Сураныч, 6-16 орундуу сырсөздү киргизиңиз",
    "bz1": "жардам",
    "bz2": "Көп берилүүчү суроолор",
    "bz3": "соода эрежелери",
    "bz4": "Акчаны кантип чыгарса болот",
    "bz5": "Кантип заряддоо керек",
    "bz6": "1. Amazon Review RoBoT деген эмне?",
    "bz7": "Amazon Review RoBoT – дүйнө жүзү боюнча Amazon Review RoBoT онлайн дүкөнүнүн соодагерлерине көбүрөөк заказ сатууга жана Amazon Review RoBoT онлайн дүкөндөрүнүн серептөө маалыматтарын көбөйтүүгө жардам берген маркетингдик компания. Биз Amazon Review RoBoT, соодагерлер жана керектөөчүлөрдүн ортосунда үч тараптуу пайдалуу маркетинг жана жылдыруу моделин түзүүгө умтулабыз. Акыркы P2P blockchain технологиясы менен айкалышып, керектөөчүлөр жана соодагерлер USDT (TRC20, ERC20) аркылуу тез туташат. Катталган колдонуучулар заказдар боюнча комиссияларды ала алышат, ал эми соодагерлер дүкөнүнүн сатуу маалыматтарын көбөйтө алышат. Бул Интернет блокчейн моделиндеги эң акыркы пайда модели!",
    "bz8": "2. Amazon Review RoBoT кантип иштейт?",
    "bz9": "Amazon Review RoBoT күнүмдүк пикири жакшыртууну талап кылган өнүмдөр Amazon Review RoBoTде сатылаарын көрсөтүп турат. Колдонуучуларга буйрутманы оңой басуу керек жана система автоматтык түрдө заказга жазылууну жаратат. Колдонуучулар заказдын суммасын USDT blockchain аркылуу төлөп, күнүмдүк комиссияларды алышат.",
    "bz10": "3.Эмне үчүн бир эле валютанын баалары эки транзакцияда айырмаланат?",
    "bz11": "Баалардын айырмасы валюталардын эркин жүгүртүүсүнө шарт түзбөгөн бардык факторлордон, анын ичинде валюталарды которуунун ылдамдыгынан, тармактык шарттардан, валютага кирүүгө чектөөлөрдөн, валютаны ар кайсы региондордогу адамдардын таануусунан, ал тургай, биржалар, транзакциялар ж.б. тарабынан берилген соода жуптарынын түрлөрү менен шартталган. Ошондуктан, бир эле валютада ар кандай транзакцияларда баа айырмачылыктары болушу мүмкүн.",
    "bz12": "4. Инвестициялык пайда?",
    "bz13": "Сиз алган буюмдун баасы канчалык жогору болсо, буйрутма боюнча киреше ошончолук жогору болот. Ошол эле учурда, Amazon Review RoBoT кокусунан чоң комиссиялык буйруктарды бөлүштүрөт.",
    "bz14": "Күн сайын система автоматтык түрдө 60 продукт заказды түзүп, колдонуучуларга бөлүштүрөт. Колдонуучулар USDT аркылуу ар бир буйрутма үчүн төлөмдү бүтүрүп, 0,6% комиссия алышат. Ири комиссиялык буйруктар туш келди дайындалат.",
    "bz15": "USDT 60 заказдан кийин алынышы мүмкүн. (Эгер 60 буйрутма аткарылбаса, система күндүн калган буйрутмаларына чейин автоматтык түрдө токтойт)",
    "bz16": "Ар бир эсеп бир USDT эсебине гана байланышы мүмкүн. Ката пайда болсо, кардарларды тейлөө кызматына кайрылыңыз.",
    "bz17": "Күнүмдүк заказдарды жеткирүү аяктагандан кийин, сиз акчаны кадимкидей ала аласыз. Акча алуу башталгандан кийин 24 сааттын ичинде келет жана алууда чектөө жок.",
    "bz18": "Толуктоодон мурун, алуу дарегиңизди (TRC-20 колдойт) USDT дарегин байлаңыз. APP же веб-баракчадагы толуктоо баскычын чыкылдатып, заряддоо үчүн колдонгон блокчейнди (TRC-20) тандасаңыз болот.",
    "bz19": "Байланышкан эсептердин ортосунда өз ара толуктоо же өз ара которууга жол берилбейт. Бул зыяндуу буйрукту басып алуу жүрүм-туруму жана платформанын иштөө эрежелерине олуттуу таасирин тийгизет. Мындай жүрүм-турум табылса, система дароо эсепти тоңдуруп, ишти дисквалификациялайт.",
    "ty1": "макул",
    "ty2": "Жокко чыгаруу",
    "ty3": "Тапшыруу",
    "ty4": "TRC20 дареги",
    "ty5": "ERC20 дареги",
    "s1": "Жыйынтык киреше",
    "s2": "кызмат",
    "s3": "Биз жөнүндө",
    "s4": "жардам",
    "s5": "Партнерлор",
    "s6": "менин кызматтарым",
    "d1": "Аяктаган жок",
    "d2": "Аякталды",
    "d3": "Азырынча маалымат жок",
    "d4": "Заказ номери",
    "d5": "соода сааттары",
    "d6": "Суммасы",
    "d7": "Учурдагы тапшырмалардын саны",
    "d8": "күтүлгөн кайтарым",
    "d9": "Дагы эле керек",
    "d10": "Рейтинг",
    "j1": "Эсеп балансы",
    "j2": "Соодага киришүү",
    "j3": "Amazon Review RoBoT Amazon Review RoBoT тарабынан сатылган жана жакшыртууну талап кылган өнүмдөрдү көрсөтүү үчүн күн сайын Amazon Review RoBoT пикирлерин колдонот. Колдонуучулар буйрутманы чыкылдатуулары керек жана система автоматтык түрдө буйруктун кол тамгасын жаратат. Колдонуучулар буйрутма суммасын USDT blockchain аркылуу төлөшөт жана ар бир жолу 0,6% дан ашык комиссия ала алышат жана система чоң сыйлык тапшырыктарын туш келди бөлүштүрөт.",
    "j4": "Дал келүүнү баштоо",
    "j5": "Бүгүнкү киреше",
    "j6": "Аякталды",
    "j7": "Тапшырмалардын жалпы саны",
    "td1": "баланс",
    "td2": "Комиссия",
    "td3": "алуу",
    "td4": "адамдардын жалпы саны",
    "td5": "Колдонуучу",
    "td6": "салым кошуу",
    "td7": "Саны",
    "td8": "Статус",
    "g1": "накталай акча алуу",
    "g2": "Заряддоо",
    "g3": "Досторду чакырыңыз",
    "g4": "Азыр чакырыңыз",
    "g5": "Досторуңуз катталгандан кийин тапкан ар бир пайда үчүн сиз тиешелүү комиссияны аласыз.",
    "g6": "жеке маалымат",
    "g7": "Фонддун чоо-жайы",
    "g8": "Заряддоо рекорду",
    "g9": "Акча алуу жазуулары",
    "g10": "Тил",
    "g11": "Чыгыңыз",
    "g12": "Чын эле чыгып кеткиңиз келеби?",
    "yh1": "Колдонуучунун маалыматы",
    "yh2": "Өзгөртүү",
    "yh3": "орнотуулар",
    "yh4": "телефон",
    "yh6": "Түпнуска сырсөз",
    "yh7": "жаңы сырсөз",
    "mx1": "Комиссия чогултуу",
    "mx2": "киреше",
    "mx3": "Чыгып алуу четке кагылды",
    "mx4": "убакыт",
    "mx5": "Толуктоо ийгиликтүү болду",
    "mx6": "Четке кагылды",
    "mx7": "Күтүүдө",
    "mx8": "Акча алуу дареги",
    "mx9": "жеткиликтүү баланс",
    "mx10": "Чыныгы келүү",
    "mx11": "Сураныч, алуу суммасын киргизиңиз",
    "cz1": "Депозиттин дареги ERC20ну гана колдойт жана депозиттин минималдуу суммасы 20USDT.",
    "cz2": "Көчүрүү",
    "cz3": "Fiat валютасын тандоо",
    "cz4": "төлөө",
    "cz5": "Депозиттин дареги TRC20-USDT гана колдойт, ал эми депозиттин минималдуу суммасы 20USDT.",
    "cz6": "Депозиттин дареги ERC20ну гана колдойт жана депозиттин минималдуу суммасы 20USDT.",
    "qy1": "аймак коду",
    "yq1": "Досторду чакырыңыз",
    "yq2": "Чакыруу коду",
    "yq3": "Досторду чакырып, чоң артыкчылыктардан ырахат алыңыз",
    "yq4": "Барып чакыр",
    "zf1": "Толуктоо ыкмасы",
    "zf2": "Толуктоо ыкмасын тандаңыз",
    "zf3": "соода валюталары",
    "zf4": "соода тармагы",
    "zf5": "Соодага бар",
    "zf6": "Ийгиликтүү көчүрүлдү",
    "zf7": "соода валюталары",
    "zf8": "Сураныч колдонуңуз",
    "zf9": "Толуктоо үчүн төмөнкү дарекке акча которуңуз.",
    "zf10": "Транзакция валютасы",
    "zf11": "Көчүрүү",
    "zf12": "Сураныч, даректи жакшылап текшериңиз. Эгер сиз аны туура эмес өткөрсөңүз, аны кайра ала албайсыз.",
    "zf13": "Келүү убактысы",
    "zf14": "Болжол менен 1 ~ 5 мүнөт",
    "zf15": "Минималдуу толуктоо суммасы",
    "a1": "Дүкөн маркетинг борбору",
    "a2": "Amazon Market Robot дүкөнүнүн маркетинг борбору - бул соодагерлерге кыска убакыттын ичинде өз өнүмдөрүн сатууну жана мактоо чендерин тез жогорулатууга жардам берүү үчүн иштелип чыккан жаңы бөлүм, ошону менен өнүмдөрдүн салмагын көбөйтүү жана алардын экспозициясын андан ары жогорулатуу; колдонуучулар ар кандай тапшырмаларды аткаруу менен соодагерлерге жардам беришет жана тиешелүү сыйлыктарды алышат, ошентип эки тарап үчүн тең утуш абалына жетишишет.",
    "a3": "Учурда тутумда 30 миллион колдонуучу жана 5 миллион соодагер бар, ал эми платформада күн сайын илгерилетилген өнүмдөрдүн саны 70 миллионго жетет; кээ бир соода өнүмдөрү маркетинг борборунун тутумуна туташуу менен дүкөндүн сатуусун 60% га көбөйттү; жана маркетинг борборунун платформасынын колдонуучулары буйрутманы чыкылдатуулары керек жана маркетинг борборунун системасы автоматтык түрдө заказдын кол тамгасын жаратат. Колдонуучу буйрутма суммасын алдын ала төлөгөндөн кийин, виртуалдык транзакция аяктап, каражат дароо колдонуучунун эсебине кайтарылат. Ар бир жолу 0,6% дан ашык кошумча комиссияны алууга болот. Система ошондой эле колдонуучунун комиссиясын көбөйтүү үчүн чоң сыйлык тапшырыктарын туш келди бөлүштүрөт.",
    "a4": "Amazon Market Robot колдонуучулардын жана соодагерлердин муктаждыктарына чоң маани берип, маркетинг борборунун тутумун оптималдаштырууну жана жакшыртууну улантууда.",
    // 客服
    "kf1": "Онлайн кардарларды тейлөө",
    "kf2": "Кол менен кардарларды тейлөө аркылуу акча чыгаруу",
    "kf3": "Акча чыгаруу үчүн кол менен кардарларды тейлөөгө кайрылуу үчүн бул жерди басыңыз",
    "kf4": "Кол менен кардарларды тейлөө аркылуу толуктоо",
    "kf5": "Толуктоо үчүн кол менен кардарларды тейлөөгө кайрылуу үчүн бул жерди басыңыз",
    // 支付选项弹窗
    "zf16": "Банк картасы менен транзакциялар үчүн кардарларды тейлөөгө кайрылыңыз",
    "zf17": "Кардарларды тейлөөгө кайрылуу"
  }
  